//style maps
const styleMaps = [{
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [{
            "color": "#a7a7a7"
        }]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#737373"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#efefef"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": "#696969"
        }]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#b3b3b3"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#d6d6d6"
        }]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "weight": 1.8
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#d7d7d7"
        }]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
                "color": "#808080"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#d3d3d3"
        }]
    }
];



document.addEventListener('DOMContentLoaded', () => {

    const mapsContent = document.querySelectorAll('.acf-map-js');

    function initMapAction(el) {

        let address = el.getAttribute('data-adress');
        let zoomSet = el.getAttribute('data-zoom') * 1;

        var map = new google.maps.Map(el, {
            zoom: zoomSet ? zoomSet : 15,
            center: {
                lat: -34.397,
                lng: 150.644
            },
            styles: styleMaps
        });

        geocoder = new google.maps.Geocoder();
        codeAddress(geocoder, map, address);

        return map;
    }

    function codeAddress(geocoder, map, address) {
        geocoder.geocode({
            'address': address
        }, function (results, status) {
            if (status === 'OK') {
                map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                    icon: settings.pin_icon
                });
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }

    //Loads map to content
    window.initMap = function () {
        mapsContent.forEach((el) => {
            let map = initMapAction(el);
        });
    };

});